<template>
	<v-dialog v-model="fromToDialogVisible" width="800" persistent>
    <customDialog>
      <template v-slot:title>
        {{t('periodSetting')}}
        <button id="dialog_exit">
          <img src="@/assets/images/popup_close.png" id="btn_img" @click="cancel">
        </button>
      </template>
      <template v-slot:body>
        <v-col class="ma-0 pa-0" cols="12" align="center">
					<v-col class="ma-0 pa-0" cols="11">
						<v-row class="ma-0 pa-0 pt-2" align="center" justify="space-around">
							<v-col class="ma-0 pa-0" cols="5" align="center">
								<v-col id="grey_div" class="ma-0 pa-0" cols="auto">{{'From'}}</v-col>
							</v-col>
							<v-col class="ma-0 pa-0" cols="1" align="center"></v-col>
							<v-col class="ma-0 pa-0" cols="5" align="center">
								<v-col id="grey_div" class="ma-0 pa-0" cols="auto">{{'To'}}</v-col>
							</v-col>
						</v-row>
						<v-row class="ma-0 pa-0 pb-7" align="center" justify="space-around">
							<v-col class="ma-0 pa-0" cols="5">
								<v-date-picker v-model="fromDate" no-title dark
									show-adjacent-months></v-date-picker>
							</v-col>
							<v-col class="ma-0 pa-0" cols="1" align="center">
								<v-img max-height="1.5rem" max-width="1.5rem" class="ma-0 pa-0"
									src="@/assets/images/arrow_right_white.png"></v-img>
							</v-col>
							<v-col class="ma-0 pa-0" cols="5">
								<v-date-picker v-model="toDate" no-title dark
									show-adjacent-months></v-date-picker>
							</v-col>
						</v-row>
					</v-col>
          <v-row class="ma-0 pa-0 pb-2" align="center" justify="center">
           	<v-btn class="ma-0 pa-0" id="grey_btn" @click="cancel"
					 		width="8rem" height="2rem">{{t('cancel')}}</v-btn>
           	<v-btn class="ma-0 pa-0 ml-2" id="blue_btn" @click="confirm"
					 		width="8rem" height="2rem">{{t('sure')}}</v-btn>
          </v-row>
        </v-col>
      </template>
    </customDialog>
  </v-dialog>
</template>

<script>
import mixin from '@/mixin';
import alanyticsMixin from '@/mixin/analytics.js';
import customDialog from '@/components/Modal.vue';
export default {
	props: {
		dialogVisible: Boolean
	},
	components: {
		customDialog
	},
	mixins: [mixin.common, alanyticsMixin],
	data: () => ({
		fromToDialogVisible: false,
		fromDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
		toDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
	}),
	watch: {
		dialogVisible: function(item) {
			this.fromToDialogVisible = item;
		},
		fromToDialogVisible: function(item) {
			this.$emit('visible', item);
		},
	},
	methods: {
		confirm() {
			const from = this.getDateStr(new Date(this.fromDate));
      const to = this.getDateStr(new Date(this.toDate));
			// 날짜 길이에 맞게 mode도 설정해야함
			const diffsecond = this.calculateBetweenTwoDate(new Date(this.fromDate), new Date(this.toDate))
			const diff = Math.abs(diffsecond / (60 * 60 * 24)); // 단위 1일(day)
			if(diff < 43) {
				const mode = 'day';
				this.$emit('fromtoEvent', { from, to, mode, fromtoEdit: true });
			} else if(diff > 42 && diff < 85) {
				const mode = 'week';
				this.$emit('fromtoEvent', { from, to, mode, fromtoEdit: true });
			} else if(diff > 84 && diff < 275) {
				const mode = 'month';
				this.$emit('fromtoEvent', { from, to, mode, fromtoEdit: true });
			} else {
				const mode = 'three';
				this.$emit('fromtoEvent', { from, to, mode, fromtoEdit: true });
			}
			this.fromToDialogVisible = false;
		},
		cancel() {
			this.fromToDialogVisible = false;
			this.$emit('cancel', true);
		}
	}
}
</script>

<style lang="scss" scoped>
#grey_div {
	background-color: grey;
	color: white;
	border-radius: 10px;
	width: 5rem;
}
::v-deep {
	// ######### DatePicker CSS #####
	.theme--dark.v-card {
		background-color: #171921;
		// border: 1px solid #4A4A4A;
	}
	.theme--dark.v-picker__body {
		background-color: #171921;
	}
	.v-date-picker-header > .v-btn > .v-btn__content .v-icon {
		color: #40AEFF;
	}
	.v-date-picker-table thead tr th {
		&:nth-child(7) {
			color: #40AEFF;
		}
		&:nth-child(1) {
			color: #B54940;
		}
	}
	.v-date-picker-table tbody tr td {
		border-top: 1px solid #4A4A4A;
		&:nth-child(1) {
			.v-btn--disabled {
				.v-btn__content {
					color: rgba(255, 255, 255, 0.3) !important;
				}
			}
			.v-btn__content {
				color: #B54940;
			}
		}
		&:nth-child(6) {
			.v-btn--disabled {
				.v-btn__content {
					color: rgba(255, 255, 255, 0.3) !important;
				}
			}
			/* .v-btn__content {
				color: #40AEFF;
			} */
		}
		&:nth-child(7) {
			.v-btn--disabled {
				.v-btn__content {
					color: rgba(255, 255, 255, 0.3) !important;
				}
			}
			.v-btn__content {
				/* color: #B54940; */
				color: #40AEFF;
			}
		}
	}
	// ##############
}
</style>